module.exports = __webpack_public_path__ + "static/media/atl.340fccd4.png";